var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',{staticClass:"switch-microphone",on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.audioConstraints ? "sci-microphone-on" : "sci-microphone-off"))])}
var staticRenderFns = []

export { render, staticRenderFns }